import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

import { ClientConfigType, ClientType } from './types'
import flowwConfig from './floww'
import maAndUdConfig from './ma&ud'
import maAndUdAdminConfig from './ma&udAdmin'
import officerPortalAdminConfig from './officerPortalAdmin'
import apMaudConfig from './ap_ma&ud'

const useClientConfig = (): ClientConfigType => {
   const clientEnum: ClientType = Config.APP_CLIENT_ENUM

   const isB2GTgLoginVersion = Config.LOGIN_VERSION === 'B2G_TG_LOGIN'

   switch (clientEnum) {
      case 'FLOWW':
         return flowwConfig
      case 'MA&UD':
         return maAndUdConfig
      case 'AP_MA&UD':
         return apMaudConfig
      case 'MA&UD_ADMIN':
         return isB2GTgLoginVersion
            ? officerPortalAdminConfig
            : maAndUdAdminConfig
      default:
         return flowwConfig
   }
}

export default useClientConfig
